import { ConfigurableColumns } from '@/components/ConfigurableColumns';
import { GenericDateFunctionField } from '@/components/GenericDateFunctionField';
import { Box, Chip } from '@mui/material';
import { ChipField, FunctionField } from 'react-admin';

export const columns: ConfigurableColumns[] = [
  {
    source: 'id',
    label: 'ID',
  },
  {
    source: 'assetType',
    label: 'Asset Type',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) => (
        <Box display="flex" gap={1} flexWrap="wrap">
          {record.assetType.map((assetType: string) => (
            <Chip key={assetType} label={assetType} />
          ))}
        </Box>
      ),
    },
  },
  {
    source: 'authorType',
    label: 'Author Type',
    GridComponent: ChipField,
  },
  {
    source: 'tagName',
    label: 'Tag Name',
    GridComponent: ChipField,
    gridComponentProps: {
      source: 'tagName',
      color: 'success',
    },
  },
  {
    source: 'createdAt',
    label: 'Created At',
    GridComponent: GenericDateFunctionField,
    exportFn: record => record.createdAt?.toString(),
  },
  {
    source: 'updatedAt',
    label: 'Updated At',
    GridComponent: GenericDateFunctionField,
    exportFn: record => record.updatedAt?.toString(),
    omit: true,
  },
  {
    source: 'deletedAt',
    label: 'Deleted At',
    GridComponent: GenericDateFunctionField,
    exportFn: record => record.deletedAt?.toString(),
    omit: true,
  },
  {
    source: 'deletedBy',
    label: 'Deleted By',
    omit: true,
  },
];
